<div class="structure-subsidiaries mb-footer">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12  my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#subsi'"></app-title-page>
            </div>
            <!-- contents -->
            <div class="col-md-12" id="subsi">
                <div class="lane-top structure pt-4">
                    <h3 class="m-title text-md-left text-center">{{ dataSection[0]?.title }} </h3>
                    <div class="bagan text-center mt-3">
                        <img class="d-md-inline-block d-none" [src]="apiAsset + dataSection[0]?.picture" alt="">
                        <img class="d-md-none d-inline-block" [src]="apiAsset + dataSection[1]?.picture" alt="">
                    </div>
                    <div class="row my-4">
                        <div class="col-6 mx-auto px-0">
                            <div class="w-line">
                                <hr class="line line-1">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <hr class="line line-2">
                            <div class="accordion-blue accordion-grey">
                                <accordion [isAnimated]="true" [closeOthers]="true">
                                    <accordion-group [panelClass]="">
                                        <div class="title"
                                             accordion-heading>
                                             {{ dataSection[2]?.title }}
                                             <span class="icon"><i class="icon ion-ios-arrow-down"></i></span>
                                        </div>
                                        <div class="desc grey" [innerHTML]="dataSection[2]?.content"></div>
                                    </accordion-group>
                                </accordion>
                            </div>
                        </div>
                        <div class="col-6">
                            <hr class="line line-2">
                            <div class="accordion-blue accordion-grey">
                                <accordion [isAnimated]="true" [closeOthers]="true">
                                    <accordion-group [panelClass]="">
                                        <div class="title"
                                             accordion-heading>
                                             {{ dataSection[3]?.title }}
                                             <span class="icon"><i class="icon ion-ios-arrow-down"></i></span>
                                        </div>
                                        <div class="desc grey" [innerHTML]="dataSection[3]?.content"></div>
                                    </accordion-group>
                                </accordion>
                            </div>
                        </div>
                    </div>
                    <div class="noted my-4" [innerHTML]="dataSection[0]?.content"> </div>
                </div>
                <div class="subsidiaries">
                    <div class="accordion-grey mt-5">
                        <accordion [isAnimated]="true" [closeOthers]="true">
                            <accordion-group [panelClass]="">
                                <div class="title"
                                     accordion-heading>
                                    {{ dataSection[4]?.title }}
                                     <span class="icon"><i class="icon ion-ios-arrow-down"></i></span>
                                </div>
                                <div class="desc white" [innerHTML]="dataSection[4]?.content"></div>
                            </accordion-group>
                        </accordion>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



